module.exports = __webpack_public_path__ + "static/media/iterativos.3351d259.png";